/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/chat/web' }">chatWEB</el-breadcrumb-item>
      <el-breadcrumb-item>{{webtitle}}</el-breadcrumb-item>
    </el-breadcrumb>
   
    <!-- 进度条 -->
    <el-steps :active="active" finish-status="finish" class="tep3" process-status="finish" align-center>
      <el-step title="基本信息"></el-step>
      <el-step title="知识库配置"></el-step>
      <el-step title="完成"></el-step>
    </el-steps>


    <!--新增-->
      <el-row type="flex" class="row-bg" justify="center">
        <el-col :span="12" >
          <el-form label-width="140px" :model="editForm" :rules="rules" ref="editForm" style="margin-top: 50px;">
            <div class="content" v-if="active==0">
             <el-form-item label="web知识库名称" prop="Name">
                  <el-input size="small" v-model="editForm.Name" auto-complete="off" placeholder="请输入"></el-input>
                </el-form-item>
              <el-row>
                <el-col :span="12">
                    <el-form-item label="知识库icon" prop="platform">
                      <el-upload
                        class="avatar-uploader"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                      </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="知识库logo" prop="platform">
                      <el-upload
                        class="avatar-uploader"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                      </el-upload>
                  </el-form-item>
                </el-col>
             </el-row>  
                <el-form-item label="主题色" prop="color1">
                  <el-color-picker v-model="editForm.color1"></el-color-picker>
                </el-form-item>
                <el-form-item label="背景文字" prop="bg_text">
                  <el-input size="small" v-model="editForm.bg_text" auto-complete="off" placeholder="请输入，如帮助中心"></el-input>
                </el-form-item>
                <el-form-item label="背景图片" prop="platform">
                      <el-upload
                        class="avatar-uploader"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb，背景图片优先高于主题色</div>
                      </el-upload>
                  </el-form-item>
                <el-form-item label="备案号" prop="bg_text">
                  <el-input size="small" v-model="editForm.bg_text" auto-complete="off" placeholder="请输入，如帮助中心"></el-input>
                </el-form-item>
                <el-form-item label="版权信息" prop="bg_text">
                  <el-input size="small" v-model="editForm.bg_text" auto-complete="off" placeholder="请输入，如帮助中心"></el-input>
                </el-form-item>
                
            </div>

            <div class="content" v-if="active==1">
            
              <el-row>
                <el-col :span="9">
                    <!-- 无极分类 -->
                    <div class="block">
                    <p>可展示知识库  <el-button type="text" size="mini" @click="() => append(null)">+</el-button></p> 
                    <el-tree
                      :data="data"
                      node-key="id"
                      default-expand-all
                      :expand-on-click-node="false">
                      <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span v-if="!data.xgclick" @click="() => handleDblClick(data)"  @dblclick="() => xgnav(data)">{{ node.label }}</span>
                        <el-input class="label_name" :autofocus="true" v-else size="mini" v-model="data.label"  @blur="() => saveEditNav(data)" @keyup.enter.native="() => saveEditNav(data)" ref="labelInput" auto-complete="off"></el-input>
                        <span>
                          <el-button
                            type="text"
                            size="mini"
                            @click="() => append(data)">
                            +
                          </el-button>
                          <el-button
                            type="text"
                            size="mini"
                            @click="() => remove(node, data)">
                            -
                          </el-button>
                        </span>
                      </span>
                    </el-tree>
                  </div>
                </el-col>
                <el-col :span="15">
                    <!-- 富文本编辑器 -->
                    <div class="net_titles">{{k_name||'请选择知识库'}}</div>
                    <editor :value="contents" @blur="handleEditorBlur"></editor>
                </el-col>
             </el-row>  
             <p class="net_titles">补充知识库</p> 
             <div class="tipx">补充知识库作为在线搜索的补充，不直接对外展示，仅在chatWEB知识库中搜索时提供回答参考。</div>

                <el-form-item label="知识库选择" prop="k_id" width="250" >
                  <el-select size="small" v-model="editForm.k_id" placeholder="请选择" class="userRole">
                    <el-option v-for="type in payType" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="是否开启联网搜索" prop="is_network">
                  <el-radio v-model="editForm.is_network" label="0">否</el-radio>
                  <el-radio v-model="editForm.is_network" label="1">是</el-radio>
                </el-form-item>
               
            </div>

            <div class="content" v-if="active==2">
             
                <el-form-item label="知识库权限" prop="is_network">
                  <el-radio v-model="editForm.is_network" label="0">公开</el-radio>
                  <el-radio v-model="editForm.is_network" label="1">密码访问<el-input style="margin-left: 20px;" size="small" v-model="editForm.Name" auto-complete="off" placeholder="请输入6-8位含两种类型密码"></el-input> </el-radio>
                </el-form-item>
                <div class="net_title"> 域名（需要完成域名备案与解析） </div>
                  <div class="nets">
                  <el-radio v-model="editForm.is_network" label="0">默认域名<el-input style="margin-left: 20px;" size="small" v-model="editForm.Name" auto-complete="off" placeholder="请输入6-8位含两种类型密码"> <template slot="append">.scszsj.com</template></el-input> </el-radio>
                  </div>
                <div class="nets">
                  <el-radio v-model="editForm.is_network" label="1">
                    自定义域名
                  </el-radio>
                  <el-input style="margin-top: 20px;margin-left: 20px;" size="small" v-model="editForm.Name" auto-complete="off" placeholder="请输入6-8位含两种类型密码"></el-input>
                </div>
            </div>
          </el-form>

          <el-row type="flex" class="row-footer" justify="center">
            <el-col :span="3">
              <el-button size="small" @click="closeDialog">保存草稿</el-button></el-col>
            <el-col :span="3" v-if="active!=0">
                    <el-button size="small" @click="up1" >上一步</el-button>
            </el-col>
            <el-col :span="3" v-if="active!=2">
              <el-button size="small" @click="next" >下一步</el-button>
            </el-col>
            <el-col :span="3" v-if="active==2">
              <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">发布</el-button>   
            </el-col>
          </el-row>
        </el-col>
    </el-row>
        


  </div>
</template>

<script>
let id = 1000;
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import editor from '../../components/editor'
export default {
  data() {
    return {
      active:0,
      webtitle:'chatWEB新增',
      xg_text:'',
      imageUrl:'',
       recommendQuestions: ["实名认证多久通过？", "SDK使用手册"], // 初始示例问题
      inputQuestion: "",
      inputMessage: '',
      circleUrl:'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      messages: [],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      payType: [
        { key: '全部', value: 0 },
        { key: 'chatWEB', value: 'chatWEB' },
        { key: 'chatBOT', value: 'chatBOT' },
        { key: 'chatAPl', value: 'chatAPl' },
      ],
      title: '新增',
      editForm: {
        Id: '',
        Name: '小冰',
        platform: '',
        type: '',
        k_id:'',
        is_network:'0',
        is_upload:'0',
        content:'你好，我是小冰，请问有什么可以帮助你的吗？',
        color1:'#409EFF',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        Name: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        platform: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      data: [{
        id: 1,
        label: '企业资质',
        xgclick:false,
        content:'',
        children: [{
          id: 4,
          label: '荣誉',
          xgclick:false,
          content:'',
        },
        {
          id: 5,
          label: '资质',
          xgclick:false,
          content:'',
        }
      ]
      }, {
        id: 2,
        label: '融资业务',
        xgclick:false,
        content:'',
        children: [{
          id: 6,
          label: '融资业务流程',
          xgclick:false,
          content:'',
        }]
      }, {
        id: 3,
        label: '常见Q&A',
        xgclick:false,
        content:'',
        children: [{
          id: 7,
          label: '常见问题',
          xgclick:false,
          content:'',
        }, {
          id: 8,
          label: '联系我们',
          xgclick:false,
          content:'',
        }]
      }],
      k_id:'',
      k_name:'',
      contents:'',
        defaultProps: {
          children: 'children',
          label: 'label'
        }
    }
  },
  // 注册组件
  components: {
    editor
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    //获取路由参数
   // this.$router.push({ path: '/chat/bot_add', query: { id: row.deptId } })
    this.id = this.$route.query.id;
    console.log(this.id)
    if(this.id){
      this.webtitle = 'chatWEB编辑'
      this.getdata(this.formInline)
    }

    // 添加用户消息
    this.messages.push({
          type: 'bot',
          content: this.editForm.content
        })
    this.messages.push({
        type: 'user',
        content: '介绍一下你们公司'
      })
      setTimeout(() => {
        this.messages.push({
          type: 'bot',
          content: '为你找到以下内容：'
        })
      }, 1000)

      this.inputMessage = ''  
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleEditorBlur(content){
      // this.contents = '';
      //  //重新渲染编辑器数据this.contents
      // if (this.$refs.editor) {
      //   this.$refs.editor.setContent(this.contents);
      // } else {
      //   this.$nextTick(() => {
      //     if (this.$refs.editor) {
      //       this.$refs.editor.setContent(this.contents);
      //     }
      //   });
      // }
      // console.log(content,22222)
      // console.log(this.k_id,22222)
      //修改参数data 下面对应ID==this.k_id的content和对应children下面的对应ID==this.k_id的content
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].id == this.k_id) {
          this.data[i].content = content;
        }else{
          for (let j = 0; j < this.data[i].children.length; j++) {
            console.log(this.k_id,this.data[i].children[j].id,666)
            if (this.data[i].children[j].id == this.k_id) {
              console.log(content,'content')
              this.data[i].children[j].content = content;
            }
          }
        }
      }
    },
    xgnav(data){
      console.log(data,3333)
      data.xgclick = true;
      this.$nextTick(() => {
        // 直接调用 Element UI 的 focus 方法
        this.$refs.labelInput.focus();
        // 如果无效，尝试聚焦原生 input：
        // this.$refs.labelInput.$el.querySelector('input').focus();
      });
      this.k_id = data.id; 
      this.k_name = data.label;
      console.log(data,555)
      console.log(this.k_id,'K_ID')
      this.contents = '请输入';
      if(data.content){
        this.contents = data.content;
      }
      console.log( this.contents,'content')
      // 重新渲染编辑器数据this.contents
      // 使用 $nextTick 确保 DOM 已更新
      this.$nextTick(() => {
        if (this.$refs.editor) {
          // 先清空编辑器内容
          this.$refs.editor.setContent('');
          // 然后设置新内容
          setTimeout(() => {
            this.$refs.editor.setContent(this.contents);
            // 如果编辑器组件有 focus 方法，可以尝试聚焦
            if (this.$refs.editor.quill) {
              this.$refs.editor.quill.focus();
            }
          }, 100);
        }
      });
    },
    handleDblClick(data){
      //this.contents = '';
      //获取点击的节点的label 和 id
      this.k_id = data.id; 
      this.k_name = data.label;
      console.log(data,555)
      console.log(this.k_id,'K_ID')
      this.contents = '请输入';
      if(data.content){
        this.contents = data.content;
      }
      console.log( this.contents,'content')
      // 重新渲染编辑器数据this.contents
      // 使用 $nextTick 确保 DOM 已更新
      this.$nextTick(() => {
        if (this.$refs.editor) {
          // 先清空编辑器内容
          this.$refs.editor.setContent('');
          // 然后设置新内容
          setTimeout(() => {
            this.$refs.editor.setContent(this.contents);
            // 如果编辑器组件有 focus 方法，可以尝试聚焦
            if (this.$refs.editor.quill) {
              this.$refs.editor.quill.focus();
            }
          }, 100);
        }
      });
    },
    saveEditNav(data){
      data.xgclick = false;
    },
    append(data) {
        if (data==null) {
          // 新增一个一级节点，弹窗输入节点label
          this.$prompt('请输入知识库名称', '添加知识库名称', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /\S+/,
            inputErrorMessage: '知识库名称不能为空'
          }).then(({ value }) => {
            this.data.push({ id: id++, label: value,xgclick:false, children: [] });
            this.$message({
              type: 'success',
              message: '添加成功'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消添加'
            });
          });
          return;
        }
        this.$prompt('请输入知识库名称', '添加知识库名称', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /\S+/,
            inputErrorMessage: '知识库名称不能为空'
          }).then(({ value }) => {
            const newChild = { id: id++, label: value,xgclick:false, children: [] };
            if (!data.children) {
              this.$set(data, 'children', []);
            }
            data.children.push(newChild);
            this.$message({
              type: 'success',
              message: '添加成功'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消添加'
            });
          });
      },

      remove(node, data) {
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex(d => d.id === data.id);
        children.splice(index, 1);
      },
    up1() {
        if (this.active-- == 0) this.active = 0;
      },
    next() {
        if (this.active++ > 2) this.active = 0;
      },
    addQuestion() {
      if (this.inputQuestion.trim()) {
        this.recommendQuestions.push(this.inputQuestion.trim());
        this.inputQuestion = ""; // 清空输入框
      }
    },
    deleteQuestion(index) {
      this.recommendQuestions.splice(index, 1);
    },
    handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        // if (!isJPG) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!');
        // }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,
        data: [
          {
            addUser: null,
            editUser: null,
            addTime: 1521062371000,
            editTime: 1526700200000,
            deptId: 2,
            deptName: 'XX分公司',
            deptNo: '1',
            parentId: 1
          },
        ]
      }
      this.loading = false
      this.listData = res.data
      this.pageparm.currentPage = res.data.page_info.page
      this.pageparm.pageSize = res.data.page_info.page_size
      this.pageparm.total = res.count
      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // deptList(parameter)
      //   .then(res => {
      //     this.loading = false
      //     if (res.success == false) {
      //       this.$message({
      //         type: 'info',
      //         message: res.msg
      //       })
      //     } else {
      //       this.listData = res.data
      //       // 分页赋值
      //       this.pageparm.currentPage = res.data.page_info.page
      //       this.pageparm.pageSize = res.data.page_info.page_size
      //       this.pageparm.total = res.count
      //     }
      //   })
      //   .catch(err => {
      //     this.loading = false
      //     this.$message.error('菜单加载失败，请稍后再试！')
      //   })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '编辑chatAPI'
        this.editForm.Id = row.deptId
        this.editForm.Name = row.deptName
        this.editForm.platform = row.deptNo
        this.editForm.type = row.deptNo
        this.editForm.k_id = row.deptNo
        this.editForm.is_network = '0'
        this.editForm.is_upload = '0'
      } else {
        this.title = '新增'
        this.editForm.Id = ''
        this.editForm.Name = ''
        this.editForm.platform = ''
        this.editForm.type = ''
        this.editForm.k_id = ''
        this.editForm.is_network = '0'
        this.editForm.is_upload = '0'
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      console.log(this.data,33333);
      console.log(this.editForm,2222);return;
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 下线用户
    offlineUser(index, row) {
      this.$confirm('确定要让' + row.userName + '用户下线吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userExpireToken(row.userName)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '用户' + row.userName + '强制下线成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('用户下线失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.tep3{
  width: 60%;
  margin: 40px auto;
}
/deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
 .tips{
  font-size: 12px;
    color: #606266;
    margin-top: 7px;
    margin-left: 140px;
 }
 .tipx{
  font-size: 12px;
    color: #606266;
    margin-bottom: 10px;
 }
 .net_title{
  font-size: 14px;
  color: #606266;
  margin-left: 55px;
 margin-bottom: 20px;
 }
 .net_titles{
  font-size: 14px;
  color: #606266;
  margin-top: 15px;
 margin-bottom: 20px;
 }
 .label_name{
  width: 100px;
 }
.nets{
  margin-left: 95px;
  margin-bottom: 20px;
}
 recommend-container {
  width: 400px;
  padding: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.tags-container {
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.question-tag {
  margin-right: 10px;
  background: var(--user-bubble-color, #409EFF);
  color: #ffffff;
}
/deep/ .el-tag .el-tag__close{
  color: #ffffff;
}
.input-container {
  display: flex;
  gap: 10px;
}

.question-input {
  flex: 1;
}

.add-btn {
  width: 80px;
}

</style>

 
 


// WEBPACK FOOTER //
// src/views/chat/web_add.vue